<template>
    <div class="RadiatorReplaceList">
        <div class="flex-column">
            <div style="width: 100%; height: calc(100vh - 40px)">
                <DxDataGrid :ref="dataGridRef"
                            :data-source="dataSource"
                            :column-auto-width="true"
                            :row-alternation-enabled="true"
                            :allow-column-resizing="true"
                            :show-row-lines="true"
                            :show-borders="true"
                            @initialized="onInitialized"
                            @toolbar-preparing="onToolbarPreparing"
                            height="100%">

                    <DxEditing :allow-updating="true"
                               :allow-deleting="true"
                               :allow-adding="true"
                               :use-icons="true"
                               mode="cell" />

                    <DxPaging :page-size="500" />
                    <DxPager :visible="false" />
                    <DxFilterRow :visible="true"
                                 apply-filter="auto" />

                    <DxScrolling show-scrollbar="always"
                                 column-rendering-mode="standard"
                                 row-rendering-mode="standard"
                                 :mode="'virtual'"
                                 :preload-enabled="false" />

                    <DxColumn data-field="id"
                              caption="#"
                              :allowEditing="false"
                              width="50"
                              alignment="center"
                              cell-template="idColumnTemplate" />
                    <DxColumn data-field="customerId"
                              caption="Ügyfél-azonosító"
                              header-cell-template="title-header" />
                    <DxColumn data-field="oldAllocatorId"
                              caption="Régi radiátor azonosító"
                              header-cell-template="title-header" />
                    <DxColumn data-field="oldACU"
                              caption="Régi fogyasztás"
                              datatype="number"
                              type="fixedPoint"
                              :precision="4"
                              header-cell-template="title-header" />
                    <DxColumn data-field="newAllocatorId"
                              caption="Új radiátor azonosító"
                              header-cell-template="title-header" />
                    <DxColumn data-field="newACU"
                              caption="Új fogyasztás"
                              datatype="number"
                              type="fixedPoint"
                              :precision="4"
                              header-cell-template="title-header" />
                    <DxColumn data-field="replaceDate"
                              caption="Csere ideje"
                              header-cell-template="title-header"
                              alignment="right"
                              data-type="datetime" />

                    <DxColumn caption="Akciók"
                              sortOrder="0"
                              :allow-resizing="false"
                              :allow-reordering="false"
                              :min-width="60"
                              :width="100"
                              type="buttons">
                        <DxButton name="edit"
                                  hint="Szerkesztés"
                                  icon="background"
                                  :visible="false" />
                        <DxButton name="save"
                                  hint="Mentés"
                                  icon="check" />
                        <DxButton name="cancel"
                                  hint="Mégsem"
                                  icon="close" />
                        <DxButton name="delete"
                                  hint="Törlés"
                                  icon="trash" />
                    </DxColumn>

                    <template #title-header="{ data }">
                        <div class="d-flex">
                            <div class="flex-1 text-left">{{ data.column.caption }}</div>
                        </div>
                    </template>

                    <template #idColumnTemplate="{ data: cellInfo }">
                        {{ rowId(cellInfo) }}
                    </template>

                    <template #backbtn="{ data }">
                        <div>
                            <DxBtn name="back"
                                   hint="Vissza a feltöltésekhez"
                                   text="Vissza"
                                   icon="back"
                                   @click="backbtn" />
                        </div>
                    </template>

                </DxDataGrid>
            </div>
        </div>
    </div>
</template>

<script>
    import DxList from "devextreme-vue/list";
    import RadiatorReplaceListService from "../services/RadiatorReplaceList.service";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel
    } from "devextreme-vue/form";
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import DxSelectBox from "devextreme-vue/select-box";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxFilterRow,
        DxColumn,
        DxEditing,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing,
        DxRowDragging
    } from "devextreme-vue/data-grid";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import CustomStore from "devextreme/data/custom_store";
    import { DxButton as DxBtn } from 'devextreme-vue/button';
    import notify from "devextreme/ui/notify";
    import { DxLoadPanel } from 'devextreme-vue/load-panel';

    export default {
        name: 'RadiatorReplaceList',
        components: {
            DxPopup,
            DxFormItem,
            DxButtonItem,
            DxLabel,
            DxForm,
            DxToolbarItem,
            DxPopupToolbarItem,
            DxSelectBox,
            DxList,
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxPager,
            DxSorting,
            DxScrolling,
            DxFilterRow,
            DxColumn,
            DxEditing,
            DxLookup,
            DxRequiredRule,
            DxPosition,
            DxDatagridEditForm,
            DxButton,
            DxDataGridEditPopup,
            DxColumnFixing,
            DxRowDragging,
            DxDataGrid,
            DxScrollView,
            DxToolbar,
            DxBtn,
            DxLoadPanel
        },
        data() {
            return {
                datagrid: null,
                dataGridRef: null,
                dataSource: new CustomStore({
                    key: "id",
                    load: () => RadiatorReplaceListService.get(this.$router.currentRoute.params.id),
                    insert: (values) => {
                        return RadiatorReplaceListService.insert(values);
                    },
                    update: (key, values, reorder) =>
                        RadiatorReplaceListService.update({
                            key: key,
                            values: JSON.stringify(values),
                            reorder: values.hasOwnProperty('OrderIndex')
                        }),
                    remove: key => RadiatorReplaceListService.delete(key)
                }),
            };
        },
        methods: {
            onInitialized(e, level) {
                this.datagrid = e.component;
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            onToolbarPreparing(e) {
                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'backbtn'
                });
            },
            backbtn() {
                this.$router.push('/heatcalculator');
            }
        },
        computed: {
            getDataGrid() {
                return this.$refs[this.dataGridRef].instance;
            },
        },
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }
    ::v-deep .grid {
        fill-opacity: 0;
    }
    ::v-deep .dx-scrollable {
        width: 100%;
    }

    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }

    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        padding: 10px 10px 0px 10px;
    }

    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }

    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }
    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }
    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }
    ::v-deep .warning-row {
        background-color: #f9f2b1 !important;
        border-color: #f9f2b1 !important;
    }
    ::v-deep .error-row {
        background-color: #ffa1a1 !important;
        border-color: #ffa1a1 !important;
    }
    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }
    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }
</style>